const VotingScoreFormula = () => {
  return (
  <>
  (<span style={{color: 'green', fontWeight: 'bold', textDecoration: 'underline'}}>pro</span>&nbsp;&&nbsp;
  <span style={{color: 'red', fontWeight: 'bold', textDecoration: 'underline'}}>con</span>&nbsp;articles calc score)
  &nbsp;=&nbsp;<span style={{color: '#1976d2', fontWeight: 'bold', textDecoration: 'underline'}}>voting topic</span>&nbsp;score
  </>
  )
}


export default VotingScoreFormula
